/**
 * Meddelande till hyresgäst enligt 12 kap. 18 e § jordabalken — composition.
 *
 * A landlord-only notice, sent by rekommenderad post; the tenant is a
 * recipient party (`signs: false`). The 18 d Godkännande is created as a
 * connected document under it.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Meddelande till hyresgäst enligt 12 kap. 18 e § jordabalken';
const FORM_NUMBER = 'Formulär R-06';
const PREAMBLE = 'Hyresvärden informerar härmed hyresgästen om planerade ombyggnads- och ändringsåtgärder.';
export const meddelande18eV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'meddelande_18e',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Ombyggnad och ändring',
        shortTitle: 'Meddelande 18 e §',
        formNumber: FORM_NUMBER,
        statute: '12 kap. 18 e § jordabalken',
        signingMode: 'manual_delivery',
        signingPlacementAnchors: 'per-party-label',
        status: 'active',
        preamble: PREAMBLE,
        description: 'Förhandsmeddelande från hyresvärden till hyresgästen inför planerade ombyggnads- eller ändringsåtgärder enligt 12 kap. 18 e § jordabalken.',
        numberStyle: 'paragraph',
        partySlots: [
            {
                id: 'lessor',
                label: 'Hyresvärd',
                signingLabel: 'Hyresvärdens namnteckning',
                role: 'lessor',
                ordinal: 0,
                required: true,
                signs: true,
            },
            {
                id: 'lessee',
                label: 'Hyresgäst',
                role: 'lessee',
                ordinal: 0,
                required: true,
                signs: false,
                help: 'Hyresgästen är mottagare av meddelandet — undertecknar inte.',
            },
        ],
        propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
        titleSuffix: { key: 'apartment_official_number', prefix: 'lgh' },
    },
    values,
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PREAMBLE } },
        { instanceId: 'hyresvard', blockRef: 'meddelande_18e.hyresvard@v1', input: {} },
        { instanceId: 'hyresobjekt', blockRef: 'meddelande_18e.hyresobjekt@v1', input: {} },
        { instanceId: 'hyresgast', blockRef: 'meddelande_18e.hyresgast@v1', input: {} },
        { instanceId: 'information', blockRef: 'meddelande_18e.information@v1', input: {} },
        { instanceId: 'underskrift', blockRef: 'meddelande_18e.underskrift@v1', input: {} },
    ],
});
//# sourceMappingURL=meddelande_18e.js.map